const FaqHeader = () => (
  <div className="col-span-12">
    <div className="">
      <p className="mb-7 text-sm text-indigo-600 text-center font-semibold uppercase tracking-px">
        Have any questions?
      </p>
      <h2 className="mb-16 text-4xl dark:text-white md:text-6xl xl:text-10xl text-center font-bold font-heading tracking-px-n leading-none">
        Frequently Asked Questions
      </h2>
    </div>
  </div>
);
export default FaqHeader;
